/* @flow */
import React, { useContext, useState, useEffect, useRef } from "react";
import Tappable, { simpleActiveBackgroundColor } from "nx-components/Tappable";
import prefixStyles from "nx-components/utils/prefixStyles";
import Location from "nexia_mobile/models/location";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import LocalSettings from "nexia_mobile/models/local_settings";
import { createTileControlsForBuilding } from "nexia_mobile/components/Controls/createControlsForModel";
import IconGroup from "nexia_mobile/components/IconGroup";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";
import IconGroupTileWrapper from "nexia_mobile/components/Tiles/IconGroupTileWrapper";
import TileBody from "nexia_mobile/components/Tiles/TileBody";
import TileSpinner from "nexia_mobile/components/Tiles/TileSpinner";
import { IconBuilding } from "nx-components/Icons";
import { getTransitionPromise } from "nexia_mobile/components/Routing/HistoryPageTransitionController";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

type Props = {
  model: Location,
  tileStyles: {
    contents: Object,
    icon: Object,
    title: Object,
    status: Object,
  },
};

const BuildingInfoTile = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.BuildingInfoTile;
  const { model, tileStyles } = props;
  const [spinnerShown: boolean, setSpinnerShown] = useState(false);
  const isMounted: { current: boolean } = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const showSpinner = () => {
    if (isMounted.current) {
      setSpinnerShown(true);
    }
  };

  const hideSpinner = () => {
    if (isMounted.current) {
      setSpinnerShown(false);
    }
  };

  const handleTap = () => {
    const id = model.attributes.id;
    Dispatch(
      "RUN_PROMISE_WITH_SPINNER",
      () => {
        return model.fetch().then(() => {
          Dispatch("LOCATION_CHANGE", model);
          LocalSettings.setDefaultLocationId(id);
        });
      },
      languageContext.template(language.loadingBuildingTemplate, {
        buildingName: model.get("name"),
      })
    );
  };

  const styles = prefixStyles({
    iconStyle: {
      fontSize: "2.5em",
    },
  });

  const buildingName = model.get("name");
  const devices = model.get("devices");
  const deviceIcon = devices.map((device) => device.get("icon"));

  const controls = createTileControlsForBuilding(model, {
    showSpinner,
    hideSpinner,
  });

  let icons = parseIconsFromServer(deviceIcon, {
    showThermostatTemperatureModifier: true,
  });

  return (
    <Tappable onTap={handleTap} holdActiveUntil={getTransitionPromise}>
      {({ active, tapTargetRefHandler }) => (
        <div
          data-component-name="BuildingInfoTile"
          className="tile-contents"
          style={{
            ...tileStyles.contents,
            backgroundColor: simpleActiveBackgroundColor(active),
          }}
        >
          <TileBody innerRef={tapTargetRefHandler}>
            {controls ? (
              <IconGroupTileWrapper values={icons} unique>
                <IconGroup style={styles.iconStyle} values={icons} unique />
              </IconGroupTileWrapper>
            ) : (
              <IconBuilding style={styles.iconStyle} />
            )}
            <div className="tile-title" style={tileStyles.title}>
              {buildingName}
            </div>
          </TileBody>
          {spinnerShown ? <TileSpinner /> : null}
        </div>
      )}
    </Tappable>
  );
};

export default BuildingInfoTile;



// WEBPACK FOOTER //
// ./src/components/Tiles/BuildingInfoTile.jsx